// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"loader_loaderWrapper__i-ouY","fullPageWrapper":"loader_fullPageWrapper__Icbfh","loader":"loader_loader__5x2cA","spin":"loader_spin__1-Dpg"};